"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PluginManagerBase_1 = require("../PluginManagerBase");
/**
 * Plugin manager for ractive components.
 */
class RactiveComponentPluginManager extends PluginManagerBase_1.default {
}
exports.default = RactiveComponentPluginManager;
